import { render, staticRenderFns } from "./planoBimestralInfantil.vue?vue&type=template&id=44ac9ea4"
import script from "./planoBimestralInfantil.vue?vue&type=script&lang=js"
export * from "./planoBimestralInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports